import { DailyTimeReportItem } from "./DailyTimeReportItem";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const DailyTimeReport = z.object({
    dailyDurations: DailyTimeReportItem.array(),
});

export type DailyTimeReport = z.infer<typeof DailyTimeReport>;
